import Swiper from 'swiper'

const homeSlideshow = document.querySelector('.alu .swiper-container') !== null;

if(homeSlideshow){
    let nbSlides = document.querySelectorAll('.alu .swiper-container .swiper-slide').length;
    let dataSlideAuto = document.querySelector('.alu .swiper-container').getAttribute('data-slide_auto');
    let dataSlideSpeed = document.querySelector('.alu .swiper-container').getAttribute('data-slide_speed');
    dataSlideSpeed = dataSlideSpeed + '000';

    let config = {
        effect : 'fade',
        grabCursor : 'true',
        speed: 700,
        loop : true,

        fadeEffect: {
            crossFade: true
        },

        keyboard: {
            enabled: true,
        },

        mousewheel: {
            forceToAxis: true,
            releaseOnEdges : true,
        },

        // Navigation (arrow)
        navigation: {
            nextEl: `.alu .swiper-button-next`,
            prevEl: `.alu .swiper-button-prev`,
        }
    }

    if(dataSlideAuto === '1'){
        config.autoplay = {
            delay: dataSlideSpeed,
            disableOnInteraction: false,
        }
    }

    if(nbSlides > 1) {
        let swiperHome = new Swiper('.alu .swiper-container', config);
    }
}

// Slider Posts

let postsSlides = document.querySelectorAll('.posts .swiper-container .swiper-slide').length;

let postsConfig = {
    effect : 'fade',
    grabCursor : 'true',
    speed: 700,
    loop : true,
    slidesPerView: 'auto',

    fadeEffect: {
        crossFade: true
    },

    keyboard: {
        enabled: true,
    },

    mousewheel: {
        forceToAxis: true,
        releaseOnEdges : true,
    },

    navigation: { 
        nextEl: `.posts .swiper-button-next`,
        prevEl: `.posts .swiper-button-prev`,
    }
}

if(postsSlides > 1) {
    let swiperPosts = new Swiper('.posts .swiper-container', postsConfig);
}

